export const FLAG_GETTING_MAINTENANCE_FAIL_MODES =
  'FLAG_GETTING_MAINTENANCE_FAIL_MODES';
export const GET_MAINTENANCE_FAIL_MODES = 'GET_MAINTENANCE_FAIL_MODES';
export const CLEAR_MAINTENANCE_FAIL_MODES = 'CLEAR_MAINTENANCE_FAIL_MODES';
export const FLAG_MAINTENANCE_FAIL_MODE_ACTIVITY =
  'FLAG_MAINTENANCE_FAIL_MODE_ACTIVITY';
export const GET_MAINTENANCE_FAIL_MODE = 'GET_MAINTENANCE_FAIL_MODE';
export const CLEAR_MAINTENANCE_FAIL_MODE = 'CLEAR_MAINTENANCE_FAIL_MODE';
